export const LOCAL_STORAGE_SESSION_TOKEN_KEY = 'sessionToken'
export const LOCAL_STORAGE_SESSION_TOKEN_EXPIRES_AT_KEY = 'sessionTokenExpiresAt'
export const HTTP_HEADER_SESSION_TOKEN_KEY = 'X-Session-Token'
export const HTTP_HEADER_MALL_ID_KEY = 'X-Mall-Id'
export const HTTP_HEADER_MALL_SLUG_KEY = 'X-Mall-Slug'

/** Client-side session TTL: Remember me = 30 days, otherwise = 2 hours */
export const SESSION_TOKEN_TTL_MS = {
  REMEMBER_ME: 30 * 24 * 60 * 60 * 1000,
  DEFAULT: 2 * 60 * 60 * 1000,
}

export const STYLE_FILL_COLOR = 'fillColor'